import { DatePicker } from "antd";
import dayjs from "dayjs";

const AntdDateTimePickerField = ({ field, form, startValue, maxDay = 2, ...props }) => {
  // Normalize field value
  const value =
    field.value && dayjs(field.value).isValid() ? dayjs(field.value) : null;

  const disabledDate = (current) => {
    if (!current) return false;

    // Restrict for end time
    if (startValue && dayjs(startValue).isValid()) {
      const start = dayjs(startValue);
      const maxDate = start.add(maxDay, "day").endOf("day");

      // Disable anything before start or after start + maxDay
      return current.isBefore(start.startOf("day")) || current.isAfter(maxDate);
    }

    // For start date field, no restrictions
    return false;
  };

  return (
    <DatePicker
      {...props}
      value={value}
      showTime={{ format: "HH:mm" }}
      format="DD MMM YYYY HH:mm"
      className="w-100"
      style={{ width: "100%" }}
      onChange={(date) => {
        form.setFieldValue(
          field.name,
          date ? date.toISOString() : null // Store ISO string for consistency
        );
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabledDate={disabledDate}
    />
  );
};

export default AntdDateTimePickerField;
